import React, { useEffect } from 'react';
import PropTypes from 'constants/PropTypes';
import Navigate from 'components/Navigate';
import { i18n } from 'libs/i18n';

const ForgotPasswordConfirm = ({ onSuccess, email }) => {
    useEffect(() => {
        if (onSuccess) onSuccess(i18n('forgot-password-confirm', { email }));
    }, [onSuccess]);

    return (
        <div id="forgot-password-confirm">
            {onSuccess && (
                <React.Fragment>
                    <h1 className="panel-header border-1 border-bottom border-primary uia-forgot-password-heading">
                        {i18n('forgot-password')}
                    </h1>

                    <div className="form">
                        <Navigate
                            routeName="login"
                            text={i18n('forgot-password-return')}
                            options={{ className: 'btn btn-primary' }}
                        />
                    </div>
                </React.Fragment>
            )}
        </div>
    );
};

ForgotPasswordConfirm.propTypes = {
    email: PropTypes.string,
    onSuccess: PropTypes.func,
};

export default ForgotPasswordConfirm;
